import { DOCUMENT, Location } from '@angular/common';
import { Inject, Injectable, NgZone } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { WINDOW } from '@ng-web-apis/common';
import { environment } from 'src/environments/environment';

const has = Object.prototype.hasOwnProperty;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(DOCUMENT) private document: Document,
    private location: Location,
    private ngZone: NgZone,
  ) {}
  logCustomEvent(eventCategory: string, eventAction: string) {
    if (has.call(this.window, 'gtag')) {
      this.ngZone.runOutsideAngular(() =>
        (this.window as any).gtag('event', eventCategory, {
          ['action']: eventAction,
          ['platform']: Capacitor.isNativePlatform() ? 'App' : 'Web',
        }),
      );
    }
  }

  logPageView(url: string) {
    (window as any).dataLayer?.push({ event: 'pageChanged' });
    if (has.call(this.window, 'gtag')) {
      console.log('Here');
      this.ngZone.runOutsideAngular(() =>
        (this.window as any).gtag('event', 'page_view', {
          ['page_location']: url, // The full URL is required.
          ['send_to']: environment.gtag,
        }),
      );
    }
  }

  toggleAnalytics(on: boolean) {
    if (has.call(this.window, 'gtag')) {
      this.ngZone.runOutsideAngular(() =>
        (this.window as any).gtag('consent', 'update', {
          ['analytics_storage']: on ? 'granted' : 'denied',
        }),
      );
    }
    if (!on) {
      this.ngZone.runOutsideAngular(() => {
        const gaCookies = this.document.cookie.split('; ').filter(c => c.startsWith('_ga'));
        for (let c = 0; c < gaCookies.length; c++) {
          const d = this.window?.location?.hostname.split('.');
          while (d.length > 0) {
            const cookieBase =
              encodeURIComponent(gaCookies[c].split(';')[0].split('=')[0]) +
              '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
              d.join('.') +
              ' ;path=';
            const p = this.location.path().split('/');
            this.document.cookie = cookieBase + '/';
            while (p.length > 0) {
              this.document.cookie = cookieBase + p.join('/');
              p.pop();
            }
            d.shift();
          }
        }
      });
    }
  }
}
